import * as React from 'react';
import { useState, useEffect, useContext } from "react";
import useFetch from "../../hooks/useFetch";
import { useHistory, Redirect } from 'react-router-dom';
import { CurrentUserContext } from "../../contexts/currentUser";
import { Page } from '../page';
import { FormButton } from '../../components/buttons/button';
import { TitledBlock } from '../../components/blocks/titledBlock/titledBlock';
import { AlertMesssage } from "../../components/blocks/alertMessage/alertMessage";
import {
  Row, FormBlock, FormItem, Title, TitleInput, ErrorMessage, SubmitButtonWrap, CancelButton,
  BigGreenText, DueDateText, PaymentButtonBroup, AccountLink, NewAccountButton, EditAccountButton, RadioGroup, RadioButton,
  RadioInput, RadioLabel
} from './payment.styles';
import { useFormik, Field, FormikProvider } from 'formik';

const PaymentPage = () => {

  const [dueDate, setDueDate] = useState<string>('Loading...');
  const [days, setDays] = useState<number>(null);
  const [balance, setBalance] = useState<any>('Loading...');
  const [balance1, setBalance1] = useState<any>('0');
  const [total, setTotal] = useState<number>(0);
  const [fee, setFee] = useState<number>(0);
  const [leaseId, setLeaseId] = useState<number>(null);
  const [accounts, setAccounts] = useState<any>([]);
  const [account, setAccount] = useState<number>(0);
  const [reference, setReference] = useState(null);
  const [error, setError] = useState<any>(null);
  const [redirect, setRedirect] = useState<boolean>(false);
  const [isTotal, setIsTotal] = useState<boolean>(true);
  const [credit, setCredit] = useState<boolean>(false);
  const [createAccount, setCreateAccount] = useState<boolean>(false);
  const [accountsLoaded, setAccountsLoaded] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [{ responses }, doFetch] = useFetch('balance');
  const [accountsResult, fetchAccounts] = useFetch('getBankAccounts');
  const [paymentResult, sendPaymentData] = useFetch('sendPayment');
  const [tokenResult, updateToken] = useFetch('updateToken');
  const [removeAccountResult, removeAccount] = useFetch('removeAccount');
  const history = useHistory();
  const [currentUserState] = useContext(CurrentUserContext);

  // Formik declaration & submission
  const formik = useFormik({
    initialValues: { amount: '', bank_account: '' },
    validate,
    onSubmit: values => {
      setIsSubmitting(true);
      sendPaymentData({ method: 'POST', data: { ...values, lease_id: leaseId, fee: fee.toFixed(2) } });
    }
  });

  useEffect(() => {
    doFetch({ method: 'get' })
    fetchAccounts({ method: 'get' })
  }, []);

  useEffect(() => {
    if(!accounts[0] || !currentUserState.currentUser.settings) return;
    if(!account) setAccount(accounts[0].id);
    let acc = accounts.find((element:any) => {
      return element.id === account;
    })
    if(!acc) return;
    let fee0 = 0;
    let tempbalance = parseFloat(balance1.replace('$', '').replaceAll(',', ''));
    if(acc.cc == '0' && currentUserState.currentUser.settings.default_ach_fee) {
      setCredit(false);
      fee0 = parseFloat(currentUserState.currentUser.settings.default_ach_fee);
      setFee(fee0);
      setTotal(tempbalance + fee0);
    } else if(acc.cc == '1' && currentUserState.currentUser.settings.default_cc_fee) {
      setCredit(true);
      fee0 = currentUserState.currentUser.settings.default_cc_fee/100*tempbalance;
      setFee(fee0);
      setTotal(tempbalance + fee0);
    }
  }, [currentUserState.currentUser.settings, balance1, account]);

  useEffect(() => {
    if (!responses) return;
    setBalance(responses.balance);
    setBalance1(responses.balance);
    setDays(responses.days);
    setDueDate(responses.duedate);
    setLeaseId(responses.lease_id);
    formik.setFieldValue('amount', parseFloat(responses.balance.replace('$', '').replaceAll(',', '')));
  }, [responses]);

  /*useEffect(() => {
    if (!paymentResult.responses) return;

    const result = paymentResult.responses;
    const { xResult, xRefNum, xToken, xError, sut } = result;
    console.log(result);

    if (xResult === "A") {
      setReference(xRefNum);
      const tokenData = { token: xToken, bank_account: formik.values.bank_account }
      updateToken({ method: 'POST', data: tokenData });
    }

    if (xResult === "E") {
      if (sut) {
        setError("Something went wrong. Please re-enter Bank Account");
        setRedirect(true);
        removeAccount({ method: 'POST', data: { bank_account: formik.values.bank_account } });
      }
      else setError(xError);
      setIsSubmitting(false);
    }
  }, [paymentResult.responses]);*/

  useEffect(() => {
    if (!paymentResult.responses) return;

    const result = paymentResult.responses;
    const { Result, RefNum, GatewayStatus, Error, sut } = result;
    console.log(result);

    if (Result === "S" && GatewayStatus == "Approved") {
      setReference(result.RefNum);
      setIsSubmitting(false);
      history.push({
        pathname: '/payment_confirmation',
        state: {
          reference: result.RefNum
        },
      });
    }

    if (Result === "E" || GatewayStatus != "Approved") {
      if (sut) {
        setError("Something went wrong. Please re-enter Bank Account");
        setRedirect(true);
        removeAccount({ method: 'POST', data: { bank_account: formik.values.bank_account } });
      }
      else setError(Error);
      setIsSubmitting(false);
    }
  }, [paymentResult.responses]);

  useEffect(() => {
    if (!tokenResult.responses) return;
    setIsSubmitting(false);
    history.push({
      pathname: '/payment_confirmation',
      state: {
        reference: reference
      },
    });
  }, [tokenResult.responses]);

  useEffect(() => {
    if (!removeAccountResult.responses) return;
    //console.log(removeAccountResult.responses);
  }, [removeAccountResult.responses]);

  useEffect(() => {
    if (!accountsResult.responses) return;
    setAccountsLoaded(true);
    if (!accountsResult.responses.count) {
      setCreateAccount(true);
      return;
    }
    setAccounts(accountsResult.responses.accounts);
    formik.setFieldValue('bank_account', accountsResult.responses.accounts[0].id);
  }, [accountsResult.responses]);



  const onRadioChange = (e: any) => {
    e.persist();
    if (e.target.value === "total") {
      formik.setFieldValue('amount', parseFloat(balance.replace('$', '').replaceAll(',', '')));
      setBalance1(balance);
    }else if (e.target.value === "custom") {
      formik.setFieldValue('amount', '', false);
      setBalance1('0');
    }

    setIsTotal(!isTotal);
  };

  const onAccountChange = (e: any) => {
    e.persist();
    setAccount(e.target.value);
  };
  const onBalanceChange = (e: any) => {
    setBalance1(e.target.value);
  };

  const accountList: any = accounts.map((acc: any) => {
    return <option key={acc.id} value={acc.id}>{acc.nickname} ***{acc.account}</option>
  });

  const handleReenter = () => {
    setError(null);
    if (redirect) history.push(`/new_bank_account`)
  };

  return (
    <Page title='Payments' tabNavigation={true}>
      {currentUserState.currentUser && currentUserState.currentUser.activelease && currentUserState.currentUser.activelease.restrict_payments == "1" && <Redirect to={"/"} />}
      <div onClick={handleReenter}>
        {accountsResult.responses && <TitledBlock title='One-Time Payment'>
          <Row show={true} style={{ justifyContent: 'space-between' }}>
            <div style={{ paddingRight: 10 }}>
              {dueDate && <DueDateText>Due
                {(() => {
                  return days > 0 ? ' in ' + days + ' days' : null
                })()}
                {' '}as of {dueDate}</DueDateText>}
              <BigGreenText>{balance}</BigGreenText>

            </div>
            <PaymentButtonBroup>
              {currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_ach == '1' && <AccountLink to={{ pathname: 'new_bank_account', state: { redirect: '/payment' } }}>
                <NewAccountButton>Add Bank Account</NewAccountButton>
              </AccountLink>}
              {currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_cc == '1' && <AccountLink to={{ pathname: 'new_cc_account', state: { redirect: '/payment' } }}>
                <NewAccountButton>Add Credit Card</NewAccountButton>
              </AccountLink>}
              <AccountLink to={`/edit_accounts`}>
                <EditAccountButton>Edit Payment Methods</EditAccountButton>
              </AccountLink>
            </PaymentButtonBroup>
          </Row>
        </TitledBlock>
        }
        {createAccount && currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_ach == '1' && currentUserState.currentUser.settings.accept_cc == '0' && <Redirect to={{ pathname: 'new_bank_account', state: { redirect: '/payment', gohome: true } }} />}
        {createAccount && currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_ach == '0' && currentUserState.currentUser.settings.accept_cc == '1' && <Redirect to={{ pathname: 'new_cc_account', state: { redirect: '/payment' , gohome: true} }} />}

        {!createAccount && <Row show={accountsLoaded}>
          <FormikProvider value={formik}>

            <FormBlock onSubmit={formik.handleSubmit}>

              {error && <AlertMesssage type={'error'} message={error}></AlertMesssage>}

              <FormItem show={true}>
                <Title>Payment Amount *</Title>
              </FormItem>

              <FormItem show={true}>
                <RadioGroup>
                  <RadioButton>
                    <RadioInput
                      type="radio"
                      id="total"
                      name="amount-type"
                      value="total"
                      defaultChecked
                      onChange={onRadioChange}
                    />
                    <RadioLabel htmlFor="total">Total Balance ({balance})</RadioLabel>
                  </RadioButton>
                  <RadioButton>
                    <RadioInput
                      type="radio"
                      id="custom"
                      name="amount-type"
                      value="custom"
                      onChange={onRadioChange}
                    />
                    <RadioLabel htmlFor="custom">Custom Amount</RadioLabel>
                  </RadioButton>
                </RadioGroup>
              </FormItem>

              <FormItem show={!isTotal} onChange={onBalanceChange}>
                <Title>Enter Amount *</Title>
                <TitleInput id="amount"   type="text" error={formik.touched.amount && formik.errors.amount} {...formik.getFieldProps('amount')} />
                <ErrorMessage>{formik.touched.amount && formik.errors.amount ? formik.errors.amount : null}</ErrorMessage>
              </FormItem>

              <FormItem show={!createAccount}>
                <Title>Select Payment Method *</Title>
                <Field name="bank_account" as="select"  value={account} onChange={onAccountChange} style={{ width: "100%", height: "30px", marginTop: "10px", borderColor: "#ABB2B9" }}>
                  {accountList}
                </Field>
              </FormItem>
              {fee != 0 && <div style={{marginTop:"25px", fontSize:"14px", textAlign: "right"}}>
                {credit ? "Credit card" : "ACH"} fee: ${isNaN(fee) ? '' : fee.toFixed(2)} <hr/>
                <span style={{fontWeight: 800}}>Total amount: ${isNaN(total) ? '' : total.toFixed(2) || ''}</span>
              </div>}
              <SubmitButtonWrap newAccount={createAccount}>
                {createAccount ?
                  <FormButton type="button" active={true} onClick={() => history.push(`/new_bank_account`)}>Next</FormButton>
                  :
                  <FormButton type="submit" active={!isSubmitting} disabled={isSubmitting}>Pay Now</FormButton>
                }
                <CancelButton type="button" onClick={() => history.push(`/`)}>Cancel</CancelButton>
              </SubmitButtonWrap>
              {fee != 0 && <div style={{marginTop:"25px", fontSize:"12px", textAlign: "left", color: "grey"}}>
                *please note that there will be an additional charge of ${isNaN(fee) ? '' : fee.toFixed(2)} as processing fees. <br/>Your total transaction will be ${isNaN(total) ? '' : total.toFixed(2) || ''}
              </div>}

            </FormBlock>

          </FormikProvider>
        </Row>}
        {createAccount && <Row show={true}>
          <FormikProvider value={formik}>
            <FormBlock>
              <FormItem show={true}>
                <Title>Please add a bank account or credit card to make payments.</Title>
              </FormItem>
              <br/>
              <FormItem show={true}>
                <Title>Payment Amount *</Title>
              </FormItem>

              <FormItem show={true}>
                <RadioGroup>
                  <RadioButton>
                    <RadioInput
                        type="radio"
                        id="total"
                        name="amount-type"
                        value="total"
                        defaultChecked
                        onChange={onRadioChange}
                    />
                    <RadioLabel htmlFor="total">Total Balance ({balance})</RadioLabel>
                  </RadioButton>
                  <RadioButton>
                    <RadioInput
                        type="radio"
                        id="custom"
                        name="amount-type"
                        value="custom"
                        onChange={onRadioChange}
                    />
                    <RadioLabel htmlFor="custom">Custom Amount</RadioLabel>
                  </RadioButton>
                </RadioGroup>
              </FormItem>

              <FormItem show={!isTotal}>
                <Title>Enter Amount *</Title>
                <TitleInput id="amount"  type="text" error={formik.touched.amount && formik.errors.amount} {...formik.getFieldProps('amount')} />
                <ErrorMessage>{formik.touched.amount && formik.errors.amount ? formik.errors.amount : null}</ErrorMessage>
              </FormItem>

              <SubmitButtonWrap newAccount={createAccount}>
                <CancelButton type="button" onClick={() => history.push(`/`)}>Cancel</CancelButton>
              </SubmitButtonWrap>

            </FormBlock>

          </FormikProvider>
        </Row>}
      </div>
    </Page>
  );
}

const validate = (values: any) => {

  const errors: any = {};

  if (!values.amount) errors.amount = 'Required';
  else if (!/^\s*-?[1-9]\d*(\.\d{1,2})?\s*$/.test(values.amount)) errors.amount = 'Must contain valid amount';

  return errors;
};

export default PaymentPage;